import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BlogStateFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BlogStateFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.7046 21.3779H3.55273C2.69677 21.3779 2 20.6811 2 19.8252V4.1753C2 3.31934 2.69678 2.62305 3.55273 2.62305H16.9316C17.7876 2.62305 18.4839 3.31934 18.4839 4.1753V19.8252C18.4839 20.1016 18.2603 20.3252 17.9839 20.3252C17.7075 20.3252 17.4839 20.1016 17.4839 19.8252V4.1753C17.4839 3.87061 17.2363 3.62305 16.9316 3.62305H3.55273C3.24804 3.62305 3 3.87061 3 4.1753V19.8252C3 20.1299 3.24805 20.3779 3.55273 20.3779H19.7046C19.981 20.3779 20.2046 20.6016 20.2046 20.8779C20.2046 21.1543 19.981 21.3779 19.7046 21.3779Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7422 21.3779C18.4971 21.3779 17.4839 20.3647 17.4839 19.1196V7.76856C17.4839 7.49219 17.7075 7.26856 17.9839 7.26856H20.4478C21.3037 7.26856 22 7.96485 22 8.82081V19.1196C22 20.3648 20.9873 21.3779 19.7422 21.3779ZM18.4839 8.26855V19.1196C18.4839 19.8135 19.0483 20.3779 19.7422 20.3779C20.4355 20.3779 21 19.8135 21 19.1196V8.82079C21 8.5161 20.7524 8.26854 20.4478 8.26854L18.4839 8.26855Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.8701 8.73243H7.33448C7.05811 8.73243 6.83448 8.5088 6.83448 8.23243C6.83448 7.95606 7.05811 7.73243 7.33448 7.73243H14.8701C15.1465 7.73243 15.3701 7.95606 15.3701 8.23243C15.3701 8.5088 15.1465 8.73243 14.8701 8.73243Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.8701 12.5518H5.47656C5.20019 12.5518 4.97656 12.3281 4.97656 12.0518C4.97656 11.7754 5.20019 11.5518 5.47656 11.5518H14.8701C15.1465 11.5518 15.3701 11.7754 15.3701 12.0518C15.3701 12.3281 15.1465 12.5518 14.8701 12.5518Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.8701 16.3711H5.47656C5.20019 16.3711 4.97656 16.1475 4.97656 15.8711C4.97656 15.5947 5.20019 15.3711 5.47656 15.3711H14.8701C15.1465 15.3711 15.3701 15.5947 15.3701 15.8711C15.3701 16.1475 15.1465 16.3711 14.8701 16.3711Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BlogStateFalseIcon;
